 <template>
   <div>
      <div class="row pl-2">
         <div class="d-flex align-items-center mb-3">
         
            <button
               class="btn"
               style="font-size: 16px; color: #6c6c6c; font-weight: bold; padding: 4px"
               @click="$router.go(-1)"
               >
               <i class="fas fa-angle-left mr-2"></i>Back
               </button>
            <span class="mx-2 text-muted">|</span>
            <span class="text-muted">NOPOL : {{ nopol }} </span>
         </div>
      </div>
      <div class="row">
         <div class="col-md-4 col-sm-12">
            <div class="card radius-10 overflow-hidden">
               <div class="card-header py-3 bg-white">
                  <p class="mb-0 text-black font-13 font-weight-bold">NOPOL : {{ nopol }}  </p>
                  <p class="mb-0 font-12 text-soft-grey">Rute : {{ kode_rute }} </p>
               </div>
               <div class="card-body pt-4 pl-0 pr-0" >
                  <div class="row" >
                     <div class="col-md-12" style="max-height: 550px; overflow-y: auto; background-color: white;" >
                        <div v-if="isLoading" class="text-center p-4">
                           <div class="spinner-border text-primary" role="status">
                              <span class="sr-only">Loading...</span>
                           </div>
                           <p class="mt-2">Memuat data lokasi...</p>
                        </div>
                        <div v-else-if="error" class="text-center p-4 text-danger">
                           <p>{{ error }}</p>
                        </div>
                        <ul v-else class="vertical-timeline" >
                           <li class="vertical-timeline-item" v-for="(item, index) in locations" :key="index">
                              <div class="timeline-content">
                                 <div class="timeline-date text-soft-grey">
                                   <div v-if="index < locations.length - 1" class="timeline-distance">
                                       {{ locations[index + 1].distance }}
                                   </div>
                                 </div>
                                 <div class="d-flex justify-content-between">
                                    <div class="d-flex justify-content-between align-items-start">
                                       <div class="col-8">
                                          <h5 class="mb-1 fw-bold">{{ item.location }}</h5>
                                          <div class="timeline-description">
                                             <p class="font-10 mb-0">
                                                Lokasi dikirim via <span class="font-weight-bold">{{ item.via }}</span> di perangkat <span class="font-weight-bold">{{ item.device }}</span>
                                             </p>
                                          </div>
                                       </div>
                                       <div class="col-4 text-end d-flex flex-column align-items-end">
                                          <p class="mb-1 text-muted" style="font-size: 8.5px;">{{ item.date }} | {{ item.time }}</p>
                                          <svg @click="updateRoute(index)" xmlns="http://www.w3.org/2000/svg" width="36" height="35" viewBox="0 0 36 35">
                                             <g transform="translate(-331 -230)">
                                                <g transform="translate(331 230)" fill="#fff" stroke="#e8e8e8" stroke-width="1">
                                                   <rect width="36" height="35" rx="5" stroke="none"/>
                                                   <rect x="0.5" y="0.5" width="35" height="34" rx="4.5" fill="none"/>
                                                </g>
                                                <path d="M6.364,18.532C1,10.751,0,9.952,0,7.093a7.093,7.093,0,1,1,14.185,0c0,2.86-1,3.658-6.364,11.439a.887.887,0,0,1-1.458,0Zm.729-8.484A2.955,2.955,0,1,0,4.137,7.093,2.955,2.955,0,0,0,7.093,10.048Z" transform="translate(341.907 238.043)" fill="#695bfc"/>
                                             </g>
                                          </svg>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </li>
                        </ul>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="col-md-8 col-sm-12">
            <div class="fixed-map-card z-index-0" >
              <div class="card">
                 <div class="card-body p-0">
                      <div id="map" style="height: 80vh; width: 100%; background: #f0f0f0;"></div>
                 </div>
              </div>
           </div>
         </div>
      </div>
   </div>
</template>

<script>
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import axios from 'axios';
import moment from 'moment';

export default {
 metaInfo: {
   title: 'Detail Monitoring Status SJ'
 },

 name: "MonitoringStatusSJDetail",
 
 data() {
   const truckData = JSON.parse(this.$store.getters.currentMonitoringSjData);
   
   return {
     nopol: truckData.nopol,
     kode_rute: truckData.kode_rute,
     no_referensi: truckData.no_to,
     tgl_sl: moment(truckData.tanggal_sj).format('YYYY-MM-DD'),
     
     map: null,
     polylineSolid: null,
     polylineDashed: null,
     markers: [],
     locations: [],
     isLoading: true,
     error: null
   };
 },

 created() {
   this.fetchLocationData();
 },

 mounted() {
   // Initialize empty map
   this.initMap();
 },

 methods: {
   initMap() {
     this.map = L.map('map').setView([-7.0, 108.5], 7);

     L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
       attribution: '',
       subdomains: 'abcd',
       maxZoom: 19
     }).addTo(this.map);
   },
   
   fetchLocationData() {
     this.isLoading = true;
     this.error = null;
     
     const apiUrl = `api/monitoring/detail-pengiriman?nopol=${this.nopol}&no_to=${this.no_referensi}&date=${this.tgl_sl}`;
     
     axios.get(apiUrl)
       .then(response => {
         if (response.data && response.data.status === 'success' && Array.isArray(response.data.data)) {
           this.processLocationData(response.data.data);
         } else {
           this.error = 'Data tidak ditemukan atau format tidak sesuai';
           console.error('API response error:', response.data);
         }
       })
       .catch(error => {
         this.error = 'Gagal mengambil data dari server';
         console.error('API request error:', error);
       })
       .finally(() => {
         this.isLoading = false;
         if (this.locations.length > 0) {
           this.renderMapWithLocations();
         }
       });
   },
   
   processLocationData(data) {
     if (!data || !Array.isArray(data)) {
       this.error = 'Format data lokasi tidak valid';
       return;
     }
     
     this.locations = data.map((loc, index) => {
       
       const scanDate = loc.tanggal_scan ? new Date(loc.tanggal_scan) : new Date();
         
         const formattedDate = scanDate.toLocaleDateString('id-ID', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
         });

         const formattedTime = scanDate.toLocaleTimeString('id-ID', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
         });
       
       return {
         id: index + 1,
         lat: loc.lat,
         lng: loc.lng,
         location: loc.location_name || `Lokasi ${index + 1}`,
         device: loc.phone_model || 'Unknown Device',
         via: loc.phone_brand ,
         date: formattedDate,
         time: formattedTime,
         distance: '' 
       };
     });
     
     this.calculateDistances();
   },
   
   calculateDistances() {
     for (let i = 0; i < this.locations.length; i++) {
       if (i === 0) {
         this.locations[i].distance = '0 km';
       } else {
         const prev = this.locations[i - 1];
         const curr = this.locations[i];
         
         const jarak = this.getDistanceKm(prev.lat, prev.lng, curr.lat, curr.lng);
         this.locations[i].distance = `${jarak} km`;
       }
     }
   },
   
   renderMapWithLocations() {

      if (this.markers.length > 0) {
       this.markers.forEach(marker => this.map.removeLayer(marker));
       this.markers = [];
     }
     
     if (this.polylineSolid) this.map.removeLayer(this.polylineSolid);
     if (this.polylineDashed) this.map.removeLayer(this.polylineDashed);
     
     if (this.locations.length === 0) return;
     
     const allCoords = this.locations.map(loc => [loc.lat, loc.lng]);
     
     this.polylineSolid = L.polyline(allCoords, {
       color: 'orange',
       weight: 3,
     }).addTo(this.map);
     
     this.locations.forEach((loc, index) => {
       const marker = L.circleMarker([loc.lat, loc.lng], {
         radius: 6,
         fillColor: index === 0 ? 'red' : 'orange',
         color: '#fff',
         weight: 1,
         fillOpacity: 1
       }).addTo(this.map);
       
       marker.bindPopup(`<b>${loc.location}</b><br>${loc.date} ${loc.time}`);
       marker.on('click', () => this.updateRoute(index));
       
       this.markers.push(marker);
     });
     
     const bounds = L.latLngBounds(allCoords);
     this.map.fitBounds(bounds, { padding: [5, 5] });
   },
   
   updateRoute(clickedIndex) {
     const solidCoords = this.locations.slice(0, clickedIndex + 1).map(l => [l.lat, l.lng]);
     const dashedCoords = this.locations.slice(clickedIndex).map(l => [l.lat, l.lng]);
     
     if (this.polylineSolid) this.map.removeLayer(this.polylineSolid);
     if (this.polylineDashed) this.map.removeLayer(this.polylineDashed);

      window.open(`https://maps.google.com?q=${this.locations[clickedIndex].lat},${this.locations[clickedIndex].lng}`, '_blank');
     
     this.polylineSolid = L.polyline(solidCoords, {
       color: 'orange',
       weight: 3
     }).addTo(this.map);
     
     this.polylineDashed = L.polyline(dashedCoords, {
       color: 'orange',
       weight: 3,
       dashArray: '5, 10'
     }).addTo(this.map);
     
     this.markers[clickedIndex].openPopup();
     
     const bounds = L.latLngBounds(solidCoords);
     this.map.fitBounds(bounds, { padding: [5, 5] });
   },
   
   getDistanceKm(lat1, lon1, lat2, lon2) {
     const R = 6371;
     const toRad = angle => angle * Math.PI / 180;
     const dLat = toRad(lat2 - lat1);
     const dLon = toRad(lon2 - lon1);
     
     const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
               Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
               Math.sin(dLon / 2) * Math.sin(dLon / 2);
     const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
     
     return (R * c).toFixed(2);
   }
 }
};
</script>


<!-- <template>
    <div>
       <div class="row pl-2">
          <div class="d-flex align-items-center mb-3">
             <a href="javascript:history.back()" class="text-dark d-flex align-items-center mr-2">
             <i class="fas fa-chevron-left mr-1"></i> 
             <strong>Back</strong>
             </a>
             <span class="mx-2 text-muted">|</span>
             <span class="text-muted">NOPOL : {{ nopol }} </span>
          </div>
       </div>
       <div class="row">
          <div class="col-md-4 col-sm-12">
             <div class="card  radius-10 overflow-hidden">
                <div class="card-header py-3 bg-white">
                   <p class="mb-0 text-black font-13 font-weight-bold">NOPOL : {{ nopol }}  </p>
                   <p class="mb-0 font-12 text-soft-grey">Rute : {{ kode_rute }} </p>
                </div>
                <div class="card-body pt-4 pl-0 pr-0" >
                   <div class="row" >
                      <div class="col-md-12" style="max-height: 550px; overflow-y: auto; background-color: white;" >
                         <ul class="vertical-timeline" >
                            <li class="vertical-timeline-item" v-for="(item, index) in locations" :key="index">
                               <div class="timeline-content">
                                  <div class="timeline-date text-soft-grey">
                                    <div v-if="index < locations.length - 1" class="timeline-distance">
                                        {{ locations[index + 1].distance }}
                                    </div>
                                </div>
                                  <div class="d-flex justify-content-between">
                                     <div class="d-flex justify-content-between align-items-start">
                                        <div class="col-8">
                                           <h5 class="mb-1 fw-bold">{{ item.location }}</h5>
                                           <div class="timeline-description">
                                              <p class="font-10 mb-0">
                                                 Lokasi dikirim via <span class="font-weight-bold">{{ item.via }}</span> di perangkat <span class="font-weight-bold">{{ item.device }}</span>
                                              </p>
                                           </div>
                                        </div>
                                        <div class="col-4 text-end d-flex flex-column align-items-end">
                                           <p class="mb-1 text-muted" style="font-size: 8.5px;">{{ item.date }} | {{ item.time }}</p>
                                           <svg @click="updateRoute(index)" xmlns="http://www.w3.org/2000/svg" width="36" height="35" viewBox="0 0 36 35">
                                              <g transform="translate(-331 -230)">
                                                 <g transform="translate(331 230)" fill="#fff" stroke="#e8e8e8" stroke-width="1">
                                                    <rect width="36" height="35" rx="5" stroke="none"/>
                                                    <rect x="0.5" y="0.5" width="35" height="34" rx="4.5" fill="none"/>
                                                 </g>
                                                 <path d="M6.364,18.532C1,10.751,0,9.952,0,7.093a7.093,7.093,0,1,1,14.185,0c0,2.86-1,3.658-6.364,11.439a.887.887,0,0,1-1.458,0Zm.729-8.484A2.955,2.955,0,1,0,4.137,7.093,2.955,2.955,0,0,0,7.093,10.048Z" transform="translate(341.907 238.043)" fill="#695bfc"/>
                                              </g>
                                           </svg>
                                        </div>
                                     </div>
                                  </div>
                               </div>
                            </li>
                          

                         </ul>
                      </div>
                   </div>
                </div>
             </div>
          </div>
          <div class="col-md-8 col-sm-12">
            
             <div class="fixed-map-card z-index-0" >
               <div class="card">
                  <div class="card-body p-0">
                       <div id="map" style="height: 80vh; width: 100%; background: #f0f0f0;"></div>
                  </div>
               </div>
            </div>


          </div>



       </div>
    </div>
 </template>
 <script>
    import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

export default {
  metaInfo: {
    title: 'Detail Truck Tracking'
  },

  name: "TruckTrackingDetail",
  created() {
    const truckTrackingData = JSON.parse(
      this.$store.state.truckTrackingData
    );
   //  this.getTruckDetail(pengecekanTruckData.id);
  },
  data() {
   

    return {

      nopol: JSON.parse(this.$store.state.truckTrackingData).nopol,
      kode_rute: JSON.parse(this.$store.state.truckTrackingData).kode_rute,
      no_referensi: JSON.parse(this.$store.state.truckTrackingData).no_referensi,
      tgl_sl: JSON.parse(this.$store.state.truckTrackingData).tgl_sl,


    map: null,
    polylineSolid: null,
    polylineDashed: null,
    markers: [],

    locations: [
    {
        id: 1,
        lat: -6.2088,
        lng: 106.8456,
        location: 'Jakarta',
        device: 'Samsung Galaxy',
        via: 'aplikasi',
        date: '4 Juni 2023',
        time: '10:00',
         distance: ''
    },
    {
        id: 2,
        lat: -6.9175,
        lng: 107.6191,
        location: 'Bandung',
        device: 'iPhone',
        via: 'web',
        date: '4 Juni 2023',
        time: '12:00',
         distance: ''
    },
    {
        id: 3,
        lat: -7.2806,
        lng: 108.9828,
        location: 'Bumiayu',
        device: 'Samsung Galaxy',
        via: 'aplikasi',
        date: '4 Juni 2023',
        time: '14:23',
         distance: ''
    },
    {
        id: 4,
        lat: -7.424278,
        lng: 109.239636,
        location: 'Purwokerto',
        device: 'Samsung Galaxy',
        via: 'aplikasi',
        date: '4 Juni 2023',
        time: '15:10',
         distance: ''
    },
    {
        id: 5,
        lat: -7.7956,
        lng: 110.3695,
        location: 'Yogyakarta',
        device: 'Xiaomi',
        via: 'aplikasi',
        date: '4 Juni 2023',
        time: '17:00',
         distance: ''
    },
    
{
    id: 8,
    lat: -6.8948,
    lng: 112.0463,
    location: 'Gresik',
    device: 'Samsung Galaxy',
    via: 'web',
    date: '4 Juni 2023',
    time: '20:05',
    distance: ''
},
{
    id: 9,
    lat: -7.2575,
    lng: 112.7521,
    location: 'Surabaya',
    device: 'iPhone',
    via: 'aplikasi',
    date: '4 Juni 2023',
    time: '21:10',
    distance: ''
},

{
    id: 12,
    lat: -5.1477,
    lng: 119.4327,
    location: 'Makassar',
    device: 'Oppo',
    via: 'web',
    date: '4 Juni 2023',
    time: '23:45',
    distance: ''
},
{
    id: 13,
    lat: -0.7893,
    lng: 113.9213,
    location: 'Palangkaraya',
    device: 'iPhone',
    via: 'aplikasi',
    date: '5 Juni 2023',
    time: '00:30',
    distance: ''
},
{
    id: 14,
    lat: 3.5952,
    lng: 98.6722,
    location: 'Medan',
    device: 'Vivo',
    via: 'web',
    date: '5 Juni 2023',
    time: '01:00',
    distance: ''
},
{
    id: 15,
    lat: -0.5022,
    lng: 117.1537,
    location: 'Samarinda',
    device: 'Xiaomi',
    via: 'aplikasi',
    date: '5 Juni 2023',
    time: '02:20',
    distance: ''
}


        ]
    };
    
  },

  created() {
    this.id = this.$route.query.nopol;
    this.fetchLocations();
  },

  mounted() {
    

    this.map = L.map('map').setView([-7.0, 108.5], 7);


    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
        attribution:
            '',
        subdomains: 'abcd',
        maxZoom: 19
        }).addTo(this.map)


    const allCoords = this.locations.map(loc => [loc.lat, loc.lng]);

    this.polylineDashed = L.polyline(allCoords, {
        color: 'orange',
        weight: 3,
        dashArray: '5, 10'
    }).addTo(this.map);


    this.locations.forEach((loc, index) => {
        const marker = L.circleMarker([loc.lat, loc.lng], {
        radius: 6,
        fillColor: 'orange',
        color: '#fff',
        weight: 1,
        fillOpacity: 1
        }).addTo(this.map);

        marker.bindPopup(`<b>${loc.location}</b><br>${loc.date} ${loc.time}`);
        marker.on('click', () => this.updateRoute(index));

        this.markers.push(marker);
    });

    for (let i = 0; i < this.locations.length; i++) {
        if (i === 0) {
            this.locations[i].distance = '0 km';
        } else {
            const prev = this.locations[i - 1];
            const curr = this.locations[i];

            const jarak = this.getDistanceKm(prev.lat, prev.lng, curr.lat, curr.lng);
            this.locations[i].distance = `${jarak} km`;
        }
        }

  },

  methods: {


    updateRoute(clickedIndex) {
    const solidCoords = this.locations.slice(0, clickedIndex + 1).map(l => [l.lat, l.lng]);
    const dashedCoords = this.locations.slice(clickedIndex).map(l => [l.lat, l.lng]);

    if (this.polylineSolid) this.map.removeLayer(this.polylineSolid);
    if (this.polylineDashed) this.map.removeLayer(this.polylineDashed);

    this.polylineSolid = L.polyline(solidCoords, {
      color: 'orange',
      weight: 3
    }).addTo(this.map);

    this.polylineDashed = L.polyline(dashedCoords, {
      color: 'orange',
      weight: 3,
      dashArray: '5, 10'
    }).addTo(this.map);

    this.markers[clickedIndex].openPopup();

    const bounds = L.latLngBounds(solidCoords);
    this.map.fitBounds(bounds, { padding: [5, 5] });

  },

  getDistanceKm(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const toRad = angle => angle * Math.PI / 180;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
              Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return (R * c).toFixed(2);
  }



  }
};
 </script> -->

 <style scoped>

.fixed-map-card {
   position: fixed;
   top: 100px;  
   z-index: 999; 
   width: 53%; 
   height: 70vh;
   border-radius: 10px;
}


    #map {
    height: 470px;
    width: 100%;
    }
    #map2 {
    height: 470px;
    width: 100%;
    }
    .vertical-timeline {
    position: relative;
    padding: 0;
    margin: 0;
    list-style: none;
    }
    .vertical-timeline::before {
    content: "";
    position: absolute;
    top: 0;
    left: 41px;
    width: 2px;
    height: 100%;
    background: #ccc;
    }
    .vertical-timeline-item {
    position: relative;
    margin-bottom: 40px;
    }
    .vertical-timeline-item::before {
    content: "";
    position: absolute;
    top: 0;
    left: 36px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #fff;
    border: 1px solid #ccc;
    }
    .vertical-timeline-item .timeline-content {
    position: relative;
    padding-left: 0px;
    padding-bottom: 20px;
    background: #ffff;
    border-radius: 2px;
    margin-left: 60px;
    }
    .vertical-timeline-item .timeline-content::before {
    content: "";
    position: absolute;
    top: 20px;
    right: -8px;
    width: 0;
    height: 0;
  
    }
    .vertical-timeline-item .timeline-content .timeline-title {
    margin-top: 0;
    margin-bottom: 10px;
    font-weight: 600;
    font-size: 15px;
    }
    .vertical-timeline-item .timeline-content .timeline-description {
    margin-bottom: 0;
    font-size: 11px;
    }
    .vertical-timeline-item .timeline-date {
    position: absolute;
    top: 110%;
    left: -90px;
    width: 110px;
    text-align: right;
    font-size: 10px;
    font-weight: 600;
    color: #777;
    transform: translateY(-50%);
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: #ffff;
    border-radius: 1px;
    z-index: 1;
    }
    .vertical-timeline-item .timeline-content .map-icon {
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
    color: #777;
    }
    .vertical-timeline-item::before {
    background: #ccc;
    }
    .vertical-timeline-item:nth-child(2)::before {
    background: #ff7f50; 
    }
    .vertical-timeline-item:nth-child(3)::before {
    background: #ffd700;
    }
    .vertical-timeline-item:nth-child(4)::before {
    background: #00ced1; 
    }
    .leaflet-popup-close-button {
    display: none;
    }
    .gm-style-iw button.gm-ui-hover-effect {
    display: none !important;
    }
 </style>